import React, {Component} from 'react';
import Link from 'react-router-dom/Link';
import Button from '@material-ui/core/Button';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepMessages from '../../../Layout/assets/img/icon-agep-messages.svg';
import IconAgepCertificate from '../../assets/img/icon-certificate.svg';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_school_details';

class SchoolDetailsPlaceholder extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        return (
            <article className="school placeholder">
                <header>
                    <div className="row">
                        <div className="col col-left col-12 col-lg-4">
                            <div className="wrapper-top">
                                <Button size="medium" className="btnBack" component={(btnProps) => <Link to={this.props.translate('routes.schools')} {...btnProps}/>}>
                                    <KeyboardBackspaceIcon className="btnIcon" />
                                    <Translate id="school_details.button_back" />
                                </Button>

                                <div className="row row-content no-gutters">
                                    <div className="col col-12">
                                        <h1>
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                        </h1>
                                    </div>
                                </div>

                                <div id="mobile-featured-image" className="d-block d-lg-none"></div>
                                <div id="mobile-featured-image-layer" className="d-block d-lg-none"></div>
                            </div>

                            <ul className="highlight clearfix">
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepPeople} alt="" />
                                    </div>
                                    <div className="content">
                                        <span className="title"><Translate id="school_details.nombre_eleves" /></span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepMessages} alt="" />
                                    </div>
                                    <div className="content">
                                        <span className="title"><Translate id="school_details.langues_instructions" /></span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <div className="icon">
                                        <img src={IconAgepCertificate} alt="" />
                                    </div>
                                    <div className="content">
                                        <span className="title"><Translate id="school_details.certifications" /></span>
                                        <span className="txt">
                                            <span className="placeholder-line"></span>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                            <Button variant="contained" color="primary" size="large" id="btn-view-website">
                                Visiter le site internet
                            </Button>
                        </div>
                        <div className="col col-right col-7 offset-1 d-none d-lg-block">
                            <div className="featured-image"></div>
                        </div>
                    </div>
                </header>
                <div className="row row-content">
                    <div className="col col-left col-4 d-none d-lg-flex d-print-flex">
                        <address>
                            <div className="inner">
                                <div className="map"></div>
                                <ul className="clearfix">
                                    <li>
                                        <span className="title"><Translate id="school_details.adresse" /></span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                            <a href="#"><Translate id="school_details.voir_google_maps" /></a>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title"><Translate id="school_details.direction" /></span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title">Tél. / Fax.</span>
                                        <div className="content">
                                            <span className="placeholder-line"></span>
                                            <span className="placeholder-line"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title"><Translate id="school_details.site_internet" /></span>
                                        <div className="content">
                                            <a href="#">www.example.com</a>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="title"><Translate id="school_details.facebook" /></span>
                                        <div className="content">
                                            <a href="#">www.facebook.com/example</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </address>
                    </div>
                    <div className="col col-right col-12 col-lg-6 offset-lg-1">
                        <section id="presentation">
                            <h2><Translate id="school_details.presentation" /></h2>
                            <div className="content">
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>
                                <span className="placeholder-line"></span>

                                <Button variant="contained" color="primary" size="medium">
                                    <Translate id="school_details.visiter_site" />
                                </Button>
                            </div>
                        </section>
                        <section id="school-degrees" className="grey">
                            <h2><Translate id="school_details.diplomes" /></h2>
                            <div className="content">
                                <ul className="items clearfix">
                                    <li>
                                <span className="icon">
                                    <ChevronRightIcon className="m-icon" />
                                </span>
                                        <span className="placeholder-line"></span>
                                    </li>
                                    <li>
                                <span className="icon">
                                    <ChevronRightIcon className="m-icon" />
                                </span>
                                        <span className="placeholder-line"></span>
                                    </li>
                                    <li>
                                <span className="icon">
                                    <ChevronRightIcon className="m-icon" />
                                </span>
                                        <span className="placeholder-line"></span>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section id="school-fees" className="grey">
                            <h2><Translate id="school_details.ecolage" /></h2>
                            <div className="content">
                                <ul className="items clearfix">
                                    <li>
                                <span className="icon">
                                    <ChevronRightIcon className="m-icon" />
                                </span>
                                        <span className="placeholder-line"></span>
                                    </li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </article>
        );
    }
}

export default withLocalize(SchoolDetailsPlaceholder);



// WEBPACK FOOTER //
// ./src/features/Schools/components/Details/SchoolDetailsPlaceholder.js